import { Box, Drawer, DrawerOverlay, DrawerContent, useBreakpointValue, DrawerCloseButton } from "@chakra-ui/react";
import Menu from "./menu"

const Sidebar = ({ isOpen, onClose }) => {
  const isMobile = useBreakpointValue({ base: true, lg: false });

  if (isMobile) {
    return (
      <Drawer isOpen={isOpen} placement="left" onClose={onClose} returnFocusOnClose={false}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <Box w="250px" h="full" marginTop={8}>
            <Menu/>
          </Box>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Box
      w={isOpen ? "250px" : "0px"}
      overflow="hidden"
      transition="width 0.3s ease"
      h="100vh"
      borderRight={isOpen ? "1px" : "0px"}
      borderColor={"gray.500"}
      marginTop={"20px"}
    >
      <Menu />
    </Box>
  );
};

export default Sidebar;